//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import {
  ADD_BASELINE,
  ADD_ITEM,
  BASELINE_NOTIFICATION,
  COPY_TASKS,
  DELETE_ITEM,
  DELETE_LOCAL_ITEMS,
  DELETE_OLD_ITEMS,
  GET_BASELINE,
  GET_ITEM,
  GET_ITEMLIST,
  GET_ITEMS,
  ITEM_ERROR,
  ITEM_KANBAN_BLOB,
  ITEM_NOTIFICATION,
  ITEM_UNLOCK,
  ITEMS_LOADING,
  ITEM_COOLDOWN,
  LOGOUT_SUCCESS,
  UPDATE_ITEM,
  WS_TASK_UPDATE,
  ITEM_BACKUP,
  ITEM_UPDATE_PERCENTAGE,
  ITEM_SHARE,
  GET_ITEMS_MULTIPROJECT,
} from "../actions/types";
import { reduceListObj } from "../components/helper/functions/functions";
// import { getGridItemsStyle } from "../components/subcomponents/tool/toolComponents/toolSubComponents/Gantt/CalendarFunctions";

function removeDoublesFromLockWebsocket(lockWebsocket) {
  lockWebsocket = reduceListObj(lockWebsocket, "email");

  return lockWebsocket;
}

let backupIni = {};
try {
  backupIni = JSON.parse(localStorage.getItem("backup"));
} catch (e) {
  console.log("localstorage error", e);
}

const initialState = {
  items: null,
  items_for_multiproject: null,
  singleItems: {},
  isLoading: false,
  itemNotification: "",
  itemError: "",
  unlockID: "",
  unlockUser: "",
  copyTasks: {},
  baselineNotification: "",
  updateTime: new Date(),
  kanbanBlob: {},
  coolDown: { id: null },
  newNotePage: {},
  backup: backupIni,
  // when we fetch data takes some ms to get
};

//will later get state from api

export default function (state = initialState, action) {
  switch (action.type) {
    case ITEM_UPDATE_PERCENTAGE:
      let items2 = state.items;
      if (action.payload.itemID && items2?.length > 0) {
        let ind = items2.findIndex((x) => x._id === action.payload.itemID);

        if (ind > -1) {
          items2[ind].percentComplete = action.payload.percentComplete;
        }

        // percentComplete = action.payload.percentComplete;
      }

      return {
        ...state,
        items: items2,
      };
    case ITEM_BACKUP:
      let backup = state.backup;
      if (action.payload.addBackup) {
        backup = {
          ...backup,
          [action.payload.backupNumber]: action.payload.item,
        };
      }

      return {
        ...state,
        backup,
      };
    case ITEM_SHARE:
      console.log("item share", action.payload);
      let singleItems5 = state.singleItems;
      if (action.payload.hasOwnProperty("_id")) {
        console.log("slfkgj");
        //in case of delete there is no new item
        singleItems5[action.payload._id] = {
          ...singleItems5[action.payload._id],
          share: action.payload.share,
        };
      }

      return {
        ...state,
        singleItems: singleItems5,
      };
    case DELETE_LOCAL_ITEMS:
      // let projectID = action.payload.projectID;
      // keepItemsForProject: the list already in the store belongs to that
      // project, so keep showing it while the refetch is in flight instead
      // of blanking the overview until the response arrives.
      if (
        action.payload?.keepItemsForProject &&
        action.payload.keepItemsForProject === state.itemsProjectID
      ) {
        return { ...state, singleItems: {} };
      }
      return {
        ...state,
        singleItems: {},
        items: null,
        itemsProjectID: null,
      };
    case ITEM_COOLDOWN:
      return {
        ...state,
        coolDown: action.payload,
      };
    case ADD_BASELINE:
      // let projectID = action.payload.projectID;
      let singleItems2 = state.singleItems;
      if (action.payload.data.hasOwnProperty("newItem")) {
        //in case of delete there is no new item
        singleItems2 = {
          ...singleItems2,
          [action.payload.data.newItem._id]: action.payload.data.newItem,
        };
      }

      // if (singleItems2.hasOwnProperty(action.payload.itemID)) {
      singleItems2[action.payload.itemID].baseline =
        action.payload.data.baseline;
      // }

      return {
        ...state,
        singleItems: singleItems2,
        baselineNotification: action.payload.requestType
          ? "Baseline added"
          : "Baseline deleted",
      };
    case GET_BASELINE:
      let singleItems3 = state.singleItems;
      singleItems3 = {
        ...singleItems3,
        [action.payload.data.baseline._id]: action.payload.data.baseline,
      };

      return {
        ...state,
        singleItems: singleItems3,
      };
    case COPY_TASKS:
      // let projectID = action.payload.projectID;
      let itemID = action.payload.itemID;
      let tasks = action.payload.tasks;
      let tc = action.payload.tc;
      let mapArr = action.payload.map;
      let resource = action.payload.resource;
      return {
        ...state,
        copyTasks: {
          // projectID,
          itemID,
          tasks,
          tc,
          mapArr,
          resource,
        },
      };
    case ITEM_UNLOCK:
      return {
        ...state,
        unlockID: action.payload.unlockID,
        unlockUser: action.payload.unlockUser,
      };
    case ITEM_NOTIFICATION:
      return {
        ...state,
        itemNotification: action.payload,
      };
    case ITEM_ERROR:
      return {
        ...state,
        itemError: action.payload,
      };
    case BASELINE_NOTIFICATION:
      return {
        ...state,
        baselineNotification: action.payload,
      };
    case DELETE_OLD_ITEMS:
      return {
        ...state,
        items: null,
      };
    case ITEMS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ITEM_KANBAN_BLOB: {
      return {
        ...state,
        kanbanBlob: {
          ...state.kanbanBlob,
          ...action.payload,
        },
      };
    }
    case GET_ITEMS:
      let items = action.payload;

      // let fIt = items.findIndex((x) => x._id === state.unlockID);
      // if (state.unlockID !== "" && state.unlockUser === items[fIt].lockedBy) {
      //   if (fIt > -1) items[fIt].lockedBy = "";
      // }
      return {
        ...state,
        items: items,
        itemsProjectID: action.projectID || null,
        isLoading: false,
        // before request items_loading was set to true
      };
    case GET_ITEMS_MULTIPROJECT:
      let items_for_multiproject = action.payload;

      // let fIt = items.findIndex((x) => x._id === state.unlockID);
      // if (state.unlockID !== "" && state.unlockUser === items[fIt].lockedBy) {
      //   if (fIt > -1) items[fIt].lockedBy = "";
      // }
      return {
        ...state,
        items_for_multiproject,
        isLoading: false,
        // before request items_loading was set to true
      };
    case GET_ITEM:
      let singleItems = state.singleItems;
      let newNotePage = {};

      if (!singleItems[action.payload.item._id]) {
        singleItems = {
          ...singleItems,
          [action.payload.item._id]: action.payload.item,
        };
      } else {
        if (singleItems[action.payload.item._id]?.name === "note") {
          console.log("NTOTOOTO");
          console.log(
            "sisisingngnl",
            singleItems[action.payload.item._id]?.note,
          );
          console.log("action", action.payload.item);
          let pages = singleItems[action.payload.item._id]?.note?.pages;

          if (Array.isArray(pages)) {
            console.log("knrgl");
            action.payload.item?.note?.pages?.map((page) => {
              let fInd = pages.findIndex((x) => x.pageID === page.pageID);
              console.log("fidndn", fInd);
              if (fInd === -1) {
                newNotePage = page;
              }
            });
          }
        }
        singleItems[action.payload.item._id] = action.payload.item;
      }

      // const getItemInd = locSingleItems.findIndex(
      //   (q) => q._id === action.payload.item._id
      // );
      // if (getItemInd > -1) {
      //   locSingleItems[getItemInd] = action.payload.item;
      // } else {
      //   locSingleItems.push(action.payload.item);
      // }

      return {
        ...state,
        singleItems,
        updateTime: new Date(),
        newNotePage,
      };
    case WS_TASK_UPDATE:
      let singleItems4 = state.singleItems;
      if (singleItems4[action.payload.itemID]) {
        let fTInd = singleItems4[action.payload.itemID].task.findIndex(
          (x) => x._id === action.payload.taskID,
        );
        if (fTInd > -1) {
          singleItems4[action.payload.itemID].task[fTInd] =
            action.payload.taskData;
        }
      }

      return {
        ...state,
        singleItems: singleItems4,
      };
    case GET_ITEMLIST:
      let sI = state.singleItems;

      action.payload.item.map((lVal, lInd) => {
        //   let getItemListInd = sI.findIndex((q) => q._id === lVal._id);
        //   if (getItemListInd > -1) {
        //     sI[getItemListInd] = lVal;
        //   } else {
        //     sI.push(lVal);
        //   }
        // });
        if (!sI[lVal._id]) {
          sI = {
            ...sI,
            [lVal._id]: lVal,
          };
        } else {
          sI[lVal._id] = lVal;
        }
      });
      return {
        ...state,
        singleItems: sI,
      };
    case UPDATE_ITEM:
      let singleItems1 = state.singleItems;

      if (action.payload.lockWebsocket) {
        // if (singleItems1[action.payload.itemID]) {
        //   singleItems1[action.payload.itemID].lock = action.payload.lock;
        //   singleItems1[action.payload.itemID].lockWebsocket =
        //     removeDoublesFromLockWebsocket(action.payload.lockWebsocket);
        // }

        return {
          ...state,
          singleItems: singleItems1,
        };
      } else {
        let backup1 = state.backup;

        if (action.payload.deleteBackup) {
          delete backup1[action.payload.backupNumber];
        }

        if (action.payload.item) {
          singleItems1 = {
            ...singleItems1,
            [action.payload.item._id]: action.payload.item,
          };
          // singleItems1[action.payload.item._id].lockWebsocket =
          //   removeDoublesFromLockWebsocket(
          //     singleItems1[action.payload.item._id].lockWebsocket
          //   );

          let items1 = state.items;
          const updateItemInd = items1.findIndex(
            (q) => q._id === action.payload.item._id,
          );

          if (updateItemInd > -1) {
            items1[updateItemInd].lockedBy = action.payload.item.lockedBy;
            items1[updateItemInd].title = action.payload.item.title;
            items1[updateItemInd].admin = action.payload.item.admin;
            items1[updateItemInd].coworker = action.payload.item.coworker;
            items1[updateItemInd].visitor = action.payload.item.visitor;
          }

          return {
            ...state,
            backup: backup1,
            singleItems: singleItems1,
            items: items1,
            updateTime: new Date(),
          };
        } else {
          return {
            ...state,
            backup: backup1,
          };
        }
      }
    case DELETE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => item._id !== action.payload),
      };
    case ADD_ITEM:
      let itemsArr = state.items;
      let itemsArrInd = itemsArr.findIndex(
        (q) => q._id === action.payload.item._id,
      );
      if (itemsArrInd > -1) {
        itemsArr[itemsArrInd] = action.payload.item;
      } else {
        itemsArr.push(action.payload.item);
      }

      return {
        ...state,
        items: [...itemsArr],
        // ... -> because hardcopy we cannot modify it
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        items: null,
        isLoading: false,
        singleItems: [],
        // before request items_loading was set to true
      };
    default:
      return state;
  }
}
